import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { FlatStyle } from 'ol/style/flat';

import { ENTRYPOINT } from './endpoint';

const TERRITORIES_URL = `${ENTRYPOINT}territories/`;

export interface Territory {
  id: string;
  name: string;
  type: number;
  geom: string;
  area_unit: string;
  area: string;
  created_at: string;
  updated_at: string;
  notes: string;
}

export interface TerritoryType {
  id: number;
  name: string;
  style_json: FlatStyle;
}

@Injectable({ providedIn: 'root' })
export class TerritoryService {
  private readonly http = inject(HttpClient);

  load(): Observable<Territory[]> {
    return this.http.get<Territory[]>(`${TERRITORIES_URL}territory/`);
  }

  loadTypes(): Observable<TerritoryType[]> {
    return this.http.get<TerritoryType[]>(`${TERRITORIES_URL}types/`);
  }

  patchType(id: number, item: TerritoryType): Observable<TerritoryType> {
    return this.http.patch<TerritoryType>(
      `${TERRITORIES_URL}types/${id}/`,
      item,
    );
  }
}
